import { createContext } from 'react';
/**
 * Throw error when SidebarContext is used outside of context provider
 */
const invariantViolation = () => {
    throw new Error('Attempted to call useSidebar outside of sidebar context. Make sure your app is rendered inside SidebarProvider.');
};
/**
 * Sidebar Context Object
 */
export const SidebarContext = createContext({
    showSidebar: invariantViolation,
    hideSidebar: invariantViolation,
    replaceComponent: invariantViolation,
    revertComponent: invariantViolation,
    isVisible: false,
});
//# sourceMappingURL=SidebarContext.js.map